import React, { Fragment, Suspense } from 'react'
import { Switch, Route } from 'react-router'
import { BrowserRouter } from 'react-router-dom'
import Report from 'shared/components/router/report'
import { Provider } from 'react-redux'
import { getDefaultStore } from 'shared/redux/init-store'
import GifDetailRoute from 'gif-detail/components/route'
import channelSelectorItems from 'shared/redux/channel-selector'
import Search from './route'
import routes from 'shared/routes'
import ManagePageElements from 'shared/components/manage-page-elements'
import entryPoint from 'shared/components/entry-point-hoc'
import Header from 'modules/header/components/header'
import SiteContainer from '../../../site/site-container'
import GTALogger from 'shared/components/gta-logger'

const store = getDefaultStore({ channelSelectorItems }, undefined)

@entryPoint(store)
export default class App extends React.Component {
    render() {
        // parse page data
        const { groupId, pageElements } = this.props
        const { user, showSearch, showBrowse, searchTerm } = this.props

        return (
            <Provider store={store}>
                <Suspense fallback={null}>
                    <SiteContainer>
                        <BrowserRouter>
                            <Fragment>
                                <Header {...{ user, showSearch, showBrowse, searchTerm }} />
                                <Report />
                                <ManagePageElements pageElements={pageElements} />
                                <GTALogger />
                                <Switch>
                                    <Route
                                        {...routes.GIF_DETAIL}
                                        render={props => (
                                            <GifDetailRoute {...this.props} relatedGroupId={groupId} {...props} />
                                        )}
                                    />
                                    <Route render={() => <Search {...this.props} />} />
                                </Switch>
                            </Fragment>
                        </BrowserRouter>
                    </SiteContainer>
                </Suspense>
            </Provider>
        )
    }
}
